import { ChevronRightIcon } from '@sketchnote/icons';
import * as React from 'react';

import { Header, IconBorderText } from '../../quick-help';
import { useBoardExpStore } from '../store';
import { BoardSettings } from './board-settings';
import { SlackButton } from './slackbutton';

export const Home = (): JSX.Element => {
  const { closeExploreMenu, setNavigation, setIsSaveTemplateOpen } = useBoardExpStore();
  const handleOnClose = () => {
    closeExploreMenu();
  };
  const handleNavigateTo = (value) => {
    setNavigation(value);
  };

  return (
    <div className="flex flex-col justify-between h-full">
      <div>
        <Header title="Explore" onCloseClick={handleOnClose} />
        {navigations.map(({ label, value, icon, isDisabled }) => (
          <IconBorderText
            text={label}
            key={value}
            icon={icon}
            onClick={!isDisabled ? handleNavigateTo.bind(this, value) : undefined}
          />
        ))}
        <div className="">
          <IconBorderText
            text="↓ &nbsp; Save as template"
            key="savetemplate"
            onClick={() => {
              setIsSaveTemplateOpen(true);
              closeExploreMenu();
            }}
          />
        </div>
        <div className="">
          <SlackButton />
        </div>
        {/* <div>
          <BoardSettings />
        </div> */}
      </div>
    </div>
  );
};

export const navigations: {
  label: string;
  value: string;
  icon: JSX.Element;
  isDisabled?: boolean;
}[] = [
  {
    label: '📲 &nbsp; Integrations',
    value: 'integrations',
    icon: <ChevronRightIcon />,
    isDisabled: false,
  },
];
